import * as React from "react";
import {RouteComponentProps, withRouter} from "react-router";
import Routes from "../../navigation/route/Route";
import ReminderNotification from "../../model/notification/reminder/ReminderNotification";
import {markNotificationsAsRead, markNotificationsAsUnread} from "../../store/action/notification/notifications";
import {OnFailure, OnSuccess} from "../../store/action/actionHelpers";
import {Dispatch} from "redux";
import {connect} from "react-redux";
import Toast from "../helper/Toast";
import LeadStatusNotification from "../../model/notification/lead/LeadStatusNotification";
import NotificationNoteToastBody from "./view/NotificationReminderBody";
import NotificationLeadStatusBody from "./view/NotificationLeadStatusBody";
import NotificationAssigneeChangeBody from "./view/NotificationAssigneeChangeBody";
import AssigneeChangeNotification from "../../model/notification/assignee/AssigneeChangeNotification";
import LeadWatcherChangeNotification from "../../model/notification/watcher/LeadWatcherChangeNotification";
import NotificationLeadWatcherChangeBody from "./view/NotificationLeadWatcherChangeBody";
import NewThirdPartyLeadNotification from "../../model/notification/thirdPartyLead/NewThirdPartyLeadNotification";
import NotificationNewThirdPartyLeadBody from "./view/NotificationNewThirdPartyLeadBody";
import {NotificationType} from "../../model/notification/NotificationBase";
import SmsNotification from "../../model/notification/sms/SmsNotification";
import NotificationSmsBody from "./view/NotificationSmsBody";
import QuoteCommentNotification from "../../model/notification/quote/QuoteCommentNotification";
import NotificationQuoteCommentBody from "./view/NotificationQuoteCommentBody";
import QuoteStatusChangedNotification from "../../model/notification/quote/QuoteStatusChangedNotification";
import NotificationQuoteStatusChangedBody from "./view/NotificationQuoteStatusChangedBody";
import UserMentionNotification from "../../model/notification/mention/UserMentionNotification";
import NotificationUserMentionBody from "./view/NotificationUserMentionBody";
import NotificationBDPChangeBody from "./view/NotificationBDPChangeBody";
import NotificationAgentChangeBody from "./view/NotificationAgentChangeBody";
import JobUserMentionNotification from "../../model/notification/mention/JobUserMentionNotification";
import NotificationJobUserMentionBody from "./view/NotificationJobUserMentionBody";
import JobReminderNotification from "../../model/notification/reminder/JobReminderNotification";
import NotificationJobReminderToastBody from "./view/NotificationJobReminderBody";
import JobStatusNotification from "../../model/notification/job/JobStatusNotification";
import NotificationJobStatusBody from "./view/NotificationJobStatusBody";
import LeadBDPChangeNotification from "../../model/notification/assignee/LeadBDPChangeNotification";
import LeadAgentChangeNotification from "../../model/notification/assignee/LeadAgentChangeNotification";
import JobBDPChangeNotification from "../../model/notification/assignee/job/JobBDPChangeNotification";
import NotificationJobBDPChangeBody from "./view/NotificationJobBDPChangeBody";
import JobAgentChangeNotification from "../../model/notification/assignee/job/JobAgentChangeNotification";
import NotificationJobAgentChangeBody from "./view/NotificationJobAgentChangeBody";
import JobWatcherChangeNotification from "../../model/notification/watcher/JobWatcherChangeNotification";
import NotificationJobWatcherChangeBody from "./view/NotificationJobWatcherChangeBody";
import JobCreatedFromQuoteNotification from "../../model/notification/job/JobCreatedFromQuoteNotification";
import NotificationJobCreatedFromQuoteBody from "./view/NotificationJobCreatedFromQuoteBody";
import {api} from "../../api/api";
import * as moment from 'moment';
import InvoiceCreatedNotification from "../../model/notification/invoice/InvoiceCreatedNotification";
import NotificationInvoiceCreatedBody from "./view/NotificationInvoiceCreatedBody";
import BillCreatedNotification from "../../model/notification/invoice/BillCreatedNotification";
import NotificationBillCreatedBody from "./view/NotificationBillCreatedBody";
import PaymentArrivedNotification from "../../model/notification/payment/PaymentArrivedNotification";
import NotificationPaymentArrivedBody from "./view/NotificationPaymentArrivedBody";
import InvoicePaidNotification from "../../model/notification/invoice/InvoicePaidNotification";
import NotificationInvoicePaidBody from "./view/NotificationInvoicePaidBody";
import BillPaidNotification from "../../model/notification/invoice/BillPaidNotification";
import NotificationBillPaidBody from "./view/NotificationBillPaidBody";

interface IComponentProps {
	/**
	 * Notification to display in toaster.
	 */
	notification?: NotificationType
}

interface DispatchProps {
	/**
	 * Mark notification as read.
	 */
	markReadNotification: (notificationId: string, onSuccess: OnSuccess, onFailure: OnFailure) => void;

	/**
	 * Mark notification as unread.
	 */
	markUnreadNotification: (notificationId: string, onSuccess: OnSuccess, onFailure: OnFailure) => void;
}

type Props = RouteComponentProps<IComponentProps> & IComponentProps & DispatchProps

class NotificationToast extends React.Component<Props, {}> {

	constructor(props: Props) {
		super(props);
		this.routeToLeadOrJobOrInvoiceOrBillOrPayment = this.routeToLeadOrJobOrInvoiceOrBillOrPayment.bind(this);
		this.markReadNotification = this.markReadNotification.bind(this);
		this.markUnreadNotification = this.markUnreadNotification.bind(this);
		this.onViewClick = this.onViewClick.bind(this);
	}

	render() {
		return (
			<div className={"c-notification-toast"}>
				<div className={"toast-icon"}>
					<i className={"fa fa-comments"}/>
				</div>
				<div className={"toast-content"}>
					{this.props.notification instanceof ReminderNotification &&
					<NotificationNoteToastBody notification={this.props.notification}/>}
					{this.props.notification instanceof LeadStatusNotification &&
					<NotificationLeadStatusBody notification={this.props.notification}/>}
					{this.props.notification instanceof AssigneeChangeNotification &&
					<NotificationAssigneeChangeBody notification={this.props.notification}/>}
					{this.props.notification instanceof LeadBDPChangeNotification &&
					<NotificationBDPChangeBody notification={this.props.notification}/>}
					{this.props.notification instanceof LeadAgentChangeNotification &&
					<NotificationAgentChangeBody notification={this.props.notification}/>}
					{this.props.notification instanceof LeadWatcherChangeNotification &&
					<NotificationLeadWatcherChangeBody notification={this.props.notification}/>}
					{this.props.notification instanceof NewThirdPartyLeadNotification &&
					<NotificationNewThirdPartyLeadBody notification={this.props.notification}/>}
					{this.props.notification instanceof SmsNotification &&
					<NotificationSmsBody notification={this.props.notification}/>}
					{this.props.notification instanceof QuoteCommentNotification &&
					<NotificationQuoteCommentBody notification={this.props.notification}/>}
					{this.props.notification instanceof QuoteStatusChangedNotification &&
					<NotificationQuoteStatusChangedBody notification={this.props.notification}/>}
					{this.props.notification instanceof UserMentionNotification &&
					<NotificationUserMentionBody notification={this.props.notification}/>}
					{this.props.notification instanceof JobUserMentionNotification &&
					<NotificationJobUserMentionBody notification={this.props.notification}/>}
					{this.props.notification instanceof JobReminderNotification &&
					<NotificationJobReminderToastBody notification={this.props.notification}/>}
					{this.props.notification instanceof JobStatusNotification &&
					<NotificationJobStatusBody notification={this.props.notification}/>}
					{this.props.notification instanceof JobBDPChangeNotification &&
					<NotificationJobBDPChangeBody notification={this.props.notification}/>}
					{this.props.notification instanceof JobAgentChangeNotification &&
					<NotificationJobAgentChangeBody notification={this.props.notification}/>}
					{this.props.notification instanceof JobWatcherChangeNotification &&
					<NotificationJobWatcherChangeBody notification={this.props.notification}/>}
					{this.props.notification instanceof JobCreatedFromQuoteNotification &&
					<NotificationJobCreatedFromQuoteBody notification={this.props.notification}/>}
					{this.props.notification instanceof InvoiceCreatedNotification &&
					<NotificationInvoiceCreatedBody notification={this.props.notification}/>}
					{this.props.notification instanceof BillCreatedNotification &&
					<NotificationBillCreatedBody notification={this.props.notification}/>}
					{this.props.notification instanceof PaymentArrivedNotification &&
					<NotificationPaymentArrivedBody notification={this.props.notification}/>}
					{this.props.notification instanceof InvoicePaidNotification &&
					<NotificationInvoicePaidBody notification={this.props.notification}/>}
					{this.props.notification instanceof BillPaidNotification &&
					<NotificationBillPaidBody notification={this.props.notification}/>}
					<div className={"toast-actions"}>
						{this.canNavigateToLead() && <span className={"t-link"} onClick={this.onViewClick}>View</span>}
						{this.renderNotificationActions()}
					</div>
				</div>
			</div>
		);
	}

	/**
	 * On view link click
	 */
	onViewClick() {
		this.routeToLeadOrJobOrInvoiceOrBillOrPayment();
		Toast.dismiss(this.props.notification.id)
	}

	/**
	 * If user can navigate to lead details from notification toast.
	 * @returns {boolean}
	 */
	canNavigateToLead(): boolean {
		if (this.props.notification instanceof SmsNotification) {
			return (this.props.notification as SmsNotification).data.recognizedSmsData.isDefined;
		}
		else {
			return true;
		}
	}

	/**
	 * Mark notification as read.
	 */
	markReadNotification() {
		this.props.markReadNotification(this.props.notification.id,
			() => {
				Toast.dismiss(this.props.notification.id);
				api.instance.notificationApi.checkIfAnyNotificationIsUnread(moment())
			},
			() => {Toast.error("Sorry, something went wrong. Try again later.", "Mark notification as read")})
	}

	/**
	 * Mark notification as unread.
	 */
	markUnreadNotification() {
		this.props.markUnreadNotification(this.props.notification.id, () => {},
			() => {Toast.error("Sorry, something went wrong. Try again later.", "Mark notification as unread")})
	}

	/**
	 * Render notification actions.
	 */
	renderNotificationActions() {
		if (this.props.notification.read)
			return <span className={"t-link"} onClick={this.markUnreadNotification}>Mark as Unread</span>;
		return <span className={"t-link"} onClick={this.markReadNotification}>Mark as Read</span>
	}

	/**
	 * Route to Proper lead/job and pass Note Id.
	 */
	routeToLeadOrJobOrInvoiceOrBillOrPayment() {
		if (this.props.notification instanceof ReminderNotification)
			this.props.history.push(Routes.EditLead(this.props.notification.data.getLeadReferenceNumber()),
				{activeId: this.props.notification.data.noteId});
		if (this.props.notification instanceof LeadStatusNotification
			|| this.props.notification instanceof NewThirdPartyLeadNotification
			|| this.props.notification instanceof UserMentionNotification)
			this.props.history.push(Routes.EditLead(this.props.notification.data.referenceNumber));
		if (this.props.notification instanceof AssigneeChangeNotification
			|| this.props.notification instanceof LeadBDPChangeNotification
			|| this.props.notification instanceof LeadAgentChangeNotification
			|| this.props.notification instanceof LeadWatcherChangeNotification)
			this.props.history.push(Routes.EditLead(this.props.notification.data.getLeadReferenceNumber()));
		if (this.props.notification instanceof QuoteCommentNotification
			|| this.props.notification instanceof QuoteStatusChangedNotification) {
			this.props.history.push(Routes.EditLead(this.props.notification.data.leadReferenceNumber));
		}
		if (this.props.notification instanceof SmsNotification) {
			this.props.notification.data.recognizedSmsData.map(rsd => {
				this.props.history.push(Routes.EditLead(rsd.leadId));
			})
		}
		if (this.props.notification instanceof JobReminderNotification)
			this.props.history.push(Routes.EditJob(this.props.notification.data.getJobReferenceNumber()),
				{activeId: this.props.notification.data.noteId});
		if (this.props.notification instanceof JobUserMentionNotification
			|| this.props.notification instanceof JobStatusNotification
			|| this.props.notification instanceof JobCreatedFromQuoteNotification) {
			this.props.history.push(Routes.EditJob(this.props.notification.data.referenceNumber));
		}
		if (this.props.notification instanceof JobBDPChangeNotification
			|| this.props.notification instanceof JobAgentChangeNotification
			|| this.props.notification instanceof JobWatcherChangeNotification) {
			this.props.history.push(Routes.EditJob(this.props.notification.data.getJobReferenceNumber()));
		}
		if (this.props.notification instanceof InvoiceCreatedNotification
			|| this.props.notification instanceof InvoicePaidNotification) {
			this.props.history.push(Routes.InvoiceDetailsView(this.props.notification.data.jobRefNumber))
		}
		if (this.props.notification instanceof BillCreatedNotification
			|| this.props.notification instanceof BillPaidNotification) {
			this.props.history.push(Routes.BillDetailsView(this.props.notification.data.billId));
		}
		if (this.props.notification instanceof PaymentArrivedNotification) {
			this.props.history.push(this.props.notification.data.jobRefNumber.map(Routes.InvoiceDetailsView).getOrElse(
				Routes.TransactionDetailsView(this.props.notification.data.transactionId)))
		}
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		markReadNotification: (notificationId: string, onSuccess: OnSuccess, onFailure: OnFailure) => dispatch(
			markNotificationsAsRead([notificationId], onSuccess, onFailure)),
		markUnreadNotification: ((notificationId: string, onSuccess: OnSuccess, onFailure: OnFailure) => dispatch(
			markNotificationsAsUnread([notificationId], onSuccess, onFailure)))
	}
}

export default withRouter<IComponentProps>(connect(null, mapDispatchToProps)(NotificationToast));